import React from 'react'
import { connect } from "react-redux";
import { GetParamsData } from '$Deposits/lib/LibCommonData'
export class SubmitBtn extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            isTemplyDisableSubmitButton: false, //是否暫時disable submit button
        };
	}

    onSubmit = () => {
        const {onPress, submitBtn = () => { return true }} = this.props;
        const {isTemplyDisableSubmitButton} = this.state;
        const isTreu = submitBtn() && !isTemplyDisableSubmitButton; 

        if(isTreu){
            this.setState({
                isTemplyDisableSubmitButton:true
            });
    
            setTimeout(()=>{
                this.setState({
                    isTemplyDisableSubmitButton:false
                })
            },3000);
            onPress();
        }
    };

    render() {
        const {
            submitBtn = () => { return true },
            submitBtnItem = 'Tiếp Theo',
            disabledStyle = {}, // 反灰按鈕自定義Style
            OldBankLine
        } = this.props
        const { isTemplyDisableSubmitButton } = this.state;
        const { bonusName } = GetParamsData() || {};
        const isTreu = submitBtn() && !isTemplyDisableSubmitButton;
        const buttonStyle = !isTreu ? { ...disabledStyle } : {};
        return (
            <>

                {
                    !!bonusName &&
                    <div className='depositBonus'>
                        <p>Khuyến Mãi</p>
                        <div>{bonusName}</div>
                    </div>
                }
                {!!OldBankLine && OldBankLine}
                <div
                    className={isTreu ? 'submitBtnActive' : 'submitBtn'}
                    onClick={this.onSubmit}
                    style={buttonStyle}
                >
                    {submitBtnItem}
                </div>
            </>
        )
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    DepositOldBankSixNumberStatus: state.DepositOldBankSixNumberStatus,
    DepositMoneyStatus: state.DepositMoneyStatus,
    DepositMemberBanksActive: state.DepositMemberBanksActive,
    DepositDateSelect: state.DepositDateSelect,
    DepositTimeSelect: state.DepositTimeSelect,
    LBOfflineRefNo: state.LBOfflineRefNo,
});
const mapDispatchToProps = {

};
export default connect(mapStateToProps, mapDispatchToProps)(SubmitBtn);
